export default __webpack_public_path__ + "app/assets/images/common/sample-photo-7356c776dd5bfe111a607b7263f7d743.png";